import { AuthError } from "@azure/msal-browser-1p-v2";
/**
 * Error thrown when the response does not contain an account object
 */ export class NoAccountAuthErrorV2 extends AuthError {
    constructor(requestId){
        super("NoAccountAuthErrorV2", "Response has no account object.");
        if (requestId) {
            this.correlationId = requestId;
        }
    }
}
